import clm from "country-locale-map";
import { Country } from "../shared/address/Country";

export function getLocaleCode(countryCode: string): string {
    const countryInfo = clm.getCountryByAlpha2(countryCode);
    const localeCode = countryInfo?.default_locale || 'en-US';
    return localeCode.replace(/_/g, '-');
}

export function getCountryCodeFromCountryId(countries: any[], countryId: number): string {
    if(!countries || countries.length === 0) {
        return '';
    }

    const country = countries.find((c: any) => c.id === countryId);
    return country?.code || '';
}

export function getCountryNameFromCountryId(countries: Country[], countryId: number): string {
    if(!countries || countries.length === 0) {
        return '';
    }
    
    const country = countries.find((c: any) => c.id === countryId);
    return country?.display_text || '';
}